const VIPStatus = {
  NotOnboarded: "not-onboarded",
  Active: "active",
  Deactivated: "deactivated",
  Hidden: "hidden",
};

export default VIPStatus;
